module.exports = __webpack_public_path__ + "assets/images/airports-sg/mobile.svg?v=8af1411e";